import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Form, Row, Col, FormInstance } from 'antd';
import moment, { Moment } from 'moment';
import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { CompaniesInfiniteSelectField, InputDate } from '@/components/_common';
import EmployeesByCompanySelectField from '@/components/_common/EmployeesByCompanySelectField';

export interface QuotationFormData {
  companyId: number;
  employeeId: number;
  date: Moment;
}

interface QuotationFormProps {
  form: FormInstance<QuotationFormData>;
  quotationCompanyId?: number;
}

const QuotationForm = ({ form, quotationCompanyId }: QuotationFormProps) => {
  const intl = useIntl();

  const [selectedCompanyId, setSelectedCompanyId] = useState<number>();

  useEffect(() => {
    if (quotationCompanyId) {
      setSelectedCompanyId(quotationCompanyId);
    }
  }, [quotationCompanyId]);

  const handleCompanyChange = (value: number) => {
    form.resetFields(['employeeId']);
    setSelectedCompanyId(value);
  };

  // eslint-disable-next-line
  const handleValuesChange = (valuesChanged: any) => {
    const { companyId } = valuesChanged;

    if (companyId) handleCompanyChange(companyId);
  };

  const defaultEmptyFieldError = {
    required: true,
    message: intl.formatMessage({
      id: 'commons.form.errors.requiredField',
    }),
  };

  return (
    <Form form={form} onValuesChange={handleValuesChange}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FloatingFormItem
            name="companyId"
            rules={[defaultEmptyFieldError]}
            label={intl.formatMessage({
              id: 'quotations.form.company',
            })}
          >
            <CompaniesInfiniteSelectField />
          </FloatingFormItem>
        </Col>
        <Col span={24}>
          <FloatingFormItem
            name="employeeId"
            rules={[defaultEmptyFieldError]}
            label={intl.formatMessage({
              id: 'quotations.form.employee',
            })}
          >
            <EmployeesByCompanySelectField
              allowClear
              companyId={selectedCompanyId}
            />
          </FloatingFormItem>
        </Col>
        <Col span={24}>
          <FloatingFormItem
            name="date"
            rules={[defaultEmptyFieldError]}
            label={intl.formatMessage({ id: 'quotations.form.date' })}
            initialValue={moment()}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default QuotationForm;
